import { apiAxios } from '@/lib/apiAxios';
const BASE = '/internal/drivers';
export const fetchDriverLedger = async (publicId) => apiAxios.get(`${BASE}/${publicId}/ledger`).then((r) => r.data);
export const fetchDriverAssignments = async (publicId) => apiAxios.get(`${BASE}/${publicId}/assignments`).then((r) => r.data);
export const fetchDrivers = async () => apiAxios.get(BASE).then((r) => r.data);
export const fetchDriver = async (publicId) => apiAxios.get(`${BASE}/${publicId}`).then((r) => r.data);
export const postDriver = async (data) => apiAxios.post(BASE, data).then((r) => r.data);
export const putDriver = async ({ publicId, data }) => apiAxios.put(`${BASE}/${publicId}`, data).then((r) => r.data);
export const patchDriverStatus = async ({ publicId, status, }) => apiAxios.patch(`${BASE}/${publicId}/status`, { status }).then((r) => r.data);
export const uploadDriverImage = async ({ publicId, file }) => {
    const formData = new FormData();
    formData.append('vehicleImageFile', file, file.name);
    return apiAxios
        .post(`${BASE}/${publicId}/uploads`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    })
        .then((r) => r.data);
};
export const deleteDriver = async (publicId) => apiAxios.delete(`${BASE}/${publicId}`).then((r) => r.data);
